import React, {useContext} from 'react';
import {SourceContext} from '../../../context';

const AndroidPage = () => {
  const {setDocset} = useContext(SourceContext);

  setDocset('android');

  return <>Android Docs</>;
};

export default AndroidPage;
